/* ═══════════════════════════════════════════════════════════
   BRUTECH FIGHTER SELECT
   assets/brutech-choose-class.js

   Drives the stage and the roster of sections/brutech-choose-class.liquid.
   Without this file the default faction shows and every roster portrait is
   a plain link, so nothing here is required for the page to work.

   Picking a portrait, the arrows, a swipe on the stage and the arrow keys
   all call one function, select(). Only transform and opacity are animated,
   and only from CSS, so this file never has to know about reduced motion
   except for the one case it scrolls the roster by script.
   ═══════════════════════════════════════════════════════════ */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : { matches: false };

  function init(root) {
    if (!root || root.getAttribute('data-bfs-ready')) return;

    var arena = root.querySelector('[data-bfs-arena]');
    var roster = root.querySelector('[data-bfs-roster]');
    if (!arena || !roster) return;

    var panels = Array.prototype.slice.call(arena.querySelectorAll('[data-bfs-panel]'));
    var tiles = Array.prototype.slice.call(roster.querySelectorAll('[data-bfs-tile]'));
    if (!panels.length || panels.length !== tiles.length) return;

    root.setAttribute('data-bfs-ready', '1');
    root.classList.add('bfs--js');

    var prev = arena.querySelector('[data-bfs-prev]');
    var next = arena.querySelector('[data-bfs-next]');
    var live = root.querySelector('[data-bfs-live]');
    var count = panels.length;
    var current = 0;
    var enterTimer = 0;

    panels.some(function (panel, i) {
      if (!panel.hidden) { current = i; return true; }
      return false;
    });

    /* The links become tabs: the roster is the tab list, each stage is its panel */
    roster.setAttribute('role', 'tablist');
    roster.setAttribute('aria-orientation', 'horizontal');
    Array.prototype.forEach.call(roster.children, function (li) { li.setAttribute('role', 'presentation'); });

    tiles.forEach(function (tile, i) {
      var panel = panels[i];
      tile.setAttribute('role', 'tab');
      tile.setAttribute('aria-controls', panel.id);
      tile.removeAttribute('aria-current');
      panel.setAttribute('role', 'tabpanel');
      panel.setAttribute('aria-labelledby', tile.id);
    });

    if (prev) prev.hidden = false;
    if (next) next.hidden = false;

    function text(el, selector) {
      var node = el.querySelector(selector);
      return node ? node.textContent.replace(/\s+/g, ' ').trim() : '';
    }

    /* Bring a portrait to the middle of the roster when it scrolls sideways */
    function centerTile(tile, instant) {
      if (roster.scrollWidth <= roster.clientWidth + 1) return;
      var item = tile.parentNode;
      var left = item.offsetLeft - (roster.clientWidth - item.offsetWidth) / 2;
      var behavior = instant || reduceMotion.matches ? 'auto' : 'smooth';
      if (roster.scrollTo) roster.scrollTo({ left: Math.max(0, left), behavior: behavior });
      else roster.scrollLeft = Math.max(0, left);
    }

    function select(index, options) {
      options = options || {};
      var target = ((index % count) + count) % count;
      if (target === current && !options.force) return;

      var direction = options.dir || (target > current ? 'next' : 'prev');
      var leaving = panels[current];
      var arriving = panels[target];

      root.setAttribute('data-bfs-dir', direction);

      leaving.hidden = true;
      leaving.classList.remove('is-entering');
      arriving.hidden = false;

      /* Restart the entrance animation every time, even for the same panel twice */
      if (!reduceMotion.matches) {
        arriving.classList.remove('is-entering');
        void arriving.offsetWidth;
        arriving.classList.add('is-entering');
        window.clearTimeout(enterTimer);
        enterTimer = window.setTimeout(function () { arriving.classList.remove('is-entering'); }, 1000);
      }

      tiles.forEach(function (tile, i) {
        var on = i === target;
        tile.classList.toggle('is-active', on);
        tile.setAttribute('aria-selected', on ? 'true' : 'false');
        tile.tabIndex = on ? 0 : -1;
      });

      centerTile(tiles[target], options.instant);

      if (live) {
        var name = text(arriving, '.bfs-card__name');
        var role = text(arriving, '.bfs-card__role');
        live.textContent = name + (role ? ', ' + role : '') + '. ' + (target + 1) + ' of ' + count + '.';
      }

      current = target;
      if (options.focus) {
        try { tiles[target].focus({ preventScroll: true }); } catch (e) { tiles[target].focus(); }
      }
      if (!saveData()) {
        warm(target + 1);
        warm(target - 1);
      }
    }

    /* Start loading a faction's stage image before it is asked for, so the swap is instant */
    function warm(index) {
      var panel = panels[((index % count) + count) % count];
      Array.prototype.forEach.call(panel.querySelectorAll('img[loading="lazy"]'), function (img) {
        img.loading = 'eager';
      });
    }

    function saveData() {
      var c = navigator.connection;
      return !!(c && (c.saveData || /(^|-)2g$/.test(c.effectiveType || '')));
    }

    /* Roster tiles: a plain click selects. Modified clicks still open the link. */
    tiles.forEach(function (tile, i) {
      tile.setAttribute('aria-selected', i === current ? 'true' : 'false');
      tile.tabIndex = i === current ? 0 : -1;

      tile.addEventListener('click', function (event) {
        if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        event.preventDefault();
        select(i);
      });
    });

    /* Arrow keys, Home and End move along the roster. Space picks the focused tile. */
    roster.addEventListener('keydown', function (event) {
      var i = tiles.indexOf(document.activeElement);
      if (i < 0) return;
      var key = event.key;
      if (key === 'ArrowRight' || key === 'ArrowDown') select(i + 1, { focus: true, dir: 'next' });
      else if (key === 'ArrowLeft' || key === 'ArrowUp') select(i - 1, { focus: true, dir: 'prev' });
      else if (key === 'Home') select(0, { focus: true, dir: 'prev' });
      else if (key === 'End') select(count - 1, { focus: true, dir: 'next' });
      else if (key === ' ' || key === 'Spacebar') select(i);
      else return;
      event.preventDefault();
    });

    if (prev) prev.addEventListener('click', function () { select(current - 1, { dir: 'prev' }); });
    if (next) next.addEventListener('click', function () { select(current + 1, { dir: 'next' }); });

    /* A swipe on the stage changes faction. Touch and pen only, and only clearly horizontal. */
    var startX = 0;
    var startY = 0;
    var startAt = 0;
    var tracking = false;

    arena.addEventListener('pointerdown', function (event) {
      if (event.pointerType === 'mouse') return;
      tracking = true;
      startX = event.clientX;
      startY = event.clientY;
      startAt = Date.now();
    });

    arena.addEventListener('pointerup', function (event) {
      if (!tracking) return;
      tracking = false;
      var dx = event.clientX - startX;
      var dy = event.clientY - startY;
      if (Date.now() - startAt > 800) return;
      if (Math.abs(dx) < 48 || Math.abs(dx) < Math.abs(dy) * 1.4) return;
      if (dx < 0) select(current + 1, { dir: 'next' });
      else select(current - 1, { dir: 'prev' });
    });

    arena.addEventListener('pointercancel', function () { tracking = false; });

    /* Load the neighbours when the section nears the screen, everything else on first touch */
    var warmed = false;
    function warmNeighbours() {
      if (warmed || saveData()) return;
      warmed = true;
      warm(current + 1);
      warm(current - 1);
    }

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        if (entries.some(function (entry) { return entry.isIntersecting; })) {
          observer.disconnect();
          warmNeighbours();
        }
      }, { rootMargin: '600px 0px' });
      observer.observe(root);
    }

    function warmAll() {
      if (saveData()) return;
      for (var i = 0; i < count; i++) warm(i);
    }

    ['pointerenter', 'touchstart', 'focusin'].forEach(function (name) {
      roster.addEventListener(name, warmAll, { once: true, passive: true });
    });
  }

  function initAll(scope) {
    Array.prototype.forEach.call((scope || document).querySelectorAll('[data-bcc]'), init);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
  else initAll();

  /* The theme editor re-renders a section after every change */
  document.addEventListener('shopify:section:load', function (event) { initAll(event.target); });
})();
